import { Component, Input, OnInit } from '@angular/core';
import { ModuleManager } from 'src/shared/models/module-manager';

@Component({
    selector: 'cv-queue-counter-settings',
    templateUrl: './queue-counter-settings.component.html',
    styleUrls: ['./queue-counter-settings.component.scss']
})
export class QueueCounterSettingsComponent implements OnInit {

    @Input() public moduleManager: ModuleManager;
    public moduleKey;
    public context: string;
    public choice = 'both';
    public queueCounterMetricIDs = [15166, 15167, 15163, 15425, 15164];

    constructor() { }

    ngOnInit(): void {
        this.moduleKey = this.moduleManager.getModuleKey();

        this.moduleManager.addSetting({
            name: 'radio',
            required: true, // only set if required
            onMissingValue: () => { // only set if required
                // update with your error message
                // e.g.: ctrl.showMissingExampleError = true;
                // then in your markup (this is just a simple example, please adapt to your needs):
                //  <span ng-show="$ctrl.showMissingExampleError">Example setting value must be set.</span>
            },
            getValue: () => this.choice,
            onSettingLoaded: value => {
                this.choice = value;
                // onSettingsApplied() will be called in your [Template].js as well,
                //  passing a settings object with settings.exampleSetting containing the loaded value
            },
            // this is the value that will be returned if the setting has not been saved before
            defaultValue: 'both'
        });

        this.moduleManager.customSettingsAdded = true;
    }

    // return a string of wether LDQ and LDC are toggled FIX
    public setContext() {
        return "Whether to inlcude callbacks/inqueue in count";
    }

}
